/**
 * Utility to clear invalid authentication tokens
 * Run this when you get "Invalid Refresh Token" errors
 */

export function clearAuthTokens() {
  // Clear all Supabase auth related items from localStorage
  const keysToRemove = [
    'sb-rmyrcvxnptrxttwfefke-auth-token',
    'supabase.auth.token',
    'supabase.auth.refreshToken',
    'supabase.auth.expires_at',
    'supabase.auth.expires_in',
  ];

  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });

  // Clear all items that start with 'sb-'
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('sb-')) {
      localStorage.removeItem(key);
    }
  });

    // console.log('✅ Auth tokens cleared. Please refresh the page.');
}

// Auto-clear on specific errors
export function handleAuthError(error: unknown) {
  const err = error as { message?: string; code?: string };
  if (err?.message?.includes('Invalid Refresh Token') ||
      err?.message?.includes('Refresh Token Not Found') ||
      err?.code === 'invalid_grant') {
    // console.log('🔄 Detected invalid refresh token, clearing auth...');
    clearAuthTokens();
    // Force reload to reset all state
    window.location.reload();
  }
}

// Make function available globally for debugging
if (typeof window !== 'undefined') {
  (window as unknown as { clearAuthTokens: typeof clearAuthTokens }).clearAuthTokens = clearAuthTokens;
    // console.log('💡 Tip: Run clearAuthTokens() in console to clear invalid auth tokens');
}